import Image from "next/image";
import { ImgHTMLAttributes } from "react";
import { isAssetSVG } from "../helpers";
import {
  ASSET_DEFAULT_WIDTH,
  ASSET_DEFAULT_HEIGHT,
} from "@/src/components/Asset/constants";
import clsx from "clsx";

type ProductCardImageProps = ImgHTMLAttributes<HTMLImageElement>;

export function ProductCardImage(props: ProductCardImageProps) {
  /* TODO: This should have a loading state while the image loads */
  return (
    <Image
      className={clsx("h-full w-full object-contain", props.className)}
      // We use defualt height and width since product card images are always the same size end up computing to a 1:1 ratio and ~300px x ~300px
      width={ASSET_DEFAULT_WIDTH}
      height={ASSET_DEFAULT_HEIGHT}
      alt={props.alt || ""}
      src={props.src || ""}
      unoptimized={isAssetSVG(props.src || "")} // We don't optimize SVGs to avoid breaking them with image optimizations (e.g membership cards in /profile)
    />
  );
}
